// Theme extraction utility for siteContent JSON
import { FontKey, FONTS } from './fonts';

export interface ExtractedTheme {
  fontKey: FontKey;
  primaryColor: string;
}

// Default theme values
const DEFAULT_THEME: ExtractedTheme = {
  fontKey: 'poppins',
  primaryColor: '#EF4444',
};

// Clean color format (remove alpha channel if present)
function cleanColorFormat(color: string): string {
  if (!color || typeof color !== 'string') return DEFAULT_THEME.primaryColor;
  
  // Remove alpha channel from colors like #ec0909ff
  if (color.length === 9 && color.startsWith('#')) {
    return color.substring(0, 7); // Keep only #rrggbb
  }
  
  return color;
}

// Validate font key against available fonts
function validateFontKey(font: string): FontKey {
  if (!font || typeof font !== 'string') return DEFAULT_THEME.fontKey;
  
  // Check if font exists in FONTS object
  if (font in FONTS) {
    return font as FontKey;
  }
  
  return DEFAULT_THEME.fontKey;
}

// Extract theme from siteContent JSON with defaults
export function extractThemeFromSiteContent(siteContent: any): ExtractedTheme {
  if (!siteContent || !siteContent.theme) {
    return DEFAULT_THEME;
  }
  
  const theme = siteContent.theme;
  
  return {
    fontKey: validateFontKey(theme.font),
    primaryColor: cleanColorFormat(theme.primarycolor),
  };
}
